module.exports = __webpack_public_path__ + "media/assets/Setup-897915568ab2da677d83c37b137b5c6b.svg";